import axios from 'axios'
import type {AxiosError, AxiosInstance, AxiosRequestConfig} from 'axios'
import {deleteCookie, getCookieName} from '../common/utils/cookieUtils'

export class ApiService {
  api: AxiosInstance

  constructor(path = '') {
    let dynamicUrl = window.location.origin === 'http://localhost:3000' ? 'http://localhost:8000' : window.location.origin

    if (dynamicUrl.includes('ai-portal')) {
      dynamicUrl = dynamicUrl.replace('ai-portal', 'ai-prediction')
    }

    this.api = axios.create({
      baseURL: `${dynamicUrl}/api${path}`,
    })

    this.api.interceptors.response.use(
      (response) => response,
      (error: AxiosError) => {
        if (error.response?.status === 401) {
          deleteCookie(getCookieName())
        }
        return Promise.reject(error)
      }
    )
  }

  protected async get<T = any>(url: string, config?: AxiosRequestConfig): Promise<T> {
    const {data} = await this.api.get<T>(url, config)
    return data
  }

  protected async patch<T = any>(url: string, data?: any, config?: AxiosRequestConfig): Promise<T> {
    const {data: d} = await this.api.patch<T>(url, data, config)
    return d
  }

  protected async put<T = any>(url: string, data?: any, config?: AxiosRequestConfig): Promise<T> {
    const {data: d} = await this.api.put<T>(url, data, config)
    return d
  }

  protected async post<T = any>(url: string, data?: any, config?: AxiosRequestConfig): Promise<T> {
    const {data: d} = await this.api.post<T>(url, data, config)
    return d
  }

  protected async delete<T = any>(url: string, data?: any, config?: AxiosRequestConfig): Promise<T> {
    const {data: d} = await this.api.delete<T>(url, {...config, data})
    return d
  }
}
